module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_liveshow", [["div",{"class":"site-page liveshow no-pb"},[["section",{"class":"liveshow-wrapper"},[["div",{"id":"liveshow-banner-container","class":"liveshow-banner-container"}],["div",{"class":"flash-player-wrapper"},[["div",{"class":"page-width"},[["div",{"id":"flash-player-liveshow"}]]],["div",{"class":"content-report"}]]],["div",{"id":"recorded-liveshows"}]]]]],["div",{"id":"newsletter-container","class":"subscription-form-wrapper"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/liveshow.tpl
// module id = 1101
// module chunks = 4